<template>
  <div class="about-recruit com-padding-top-70 com-padding-bottom-90">
    <div class="com-content-1560">
      <div class="dn-upper text-align-center">
        <div class="com-title1">Talent recruitment</div>
        <div class="com-title2">People oriented, pay attention to the continuous growth and development of employees,
          and realize the value of all employees
        </div>
      </div>
      <div class="dn-form com-padding-top-50">
        <el-form
            :model="ruleForm" ref="ruleForm" class="el-form1">
          <el-form-item prop="title">
            <el-input v-model="ruleForm.title" placeholder="Please enter the position you want to search"></el-input>
          </el-form-item>
          <el-form-item prop="address_id">
            <el-select filterable clearable v-model="ruleForm.address_id" placeholder="Please select a work location">
              <el-option
                  v-for="item in dataSelectaddress_id" :key="item.id"
                  :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="type_id">
            <el-select filterable clearable v-model="ruleForm.type_id" placeholder="Please select position Department">
              <el-option
                  v-for="item in dataSelecttype_id" :key="item.id"
                  :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" @click="submitForm('ruleForm')"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="dn-lower com-padding-top-70">
        <el-collapse class="el-collapse1">
          <el-collapse-item v-for="(item, index) in dataHomeblock" :key="index">
            <template slot="title">
              <div class="dp-top">
                <div class="dp-zuo">{{ item.title }}</div>
                <div class="dp-you">
                  <div class="dp-p1">Nature of work：{{ item.nature }}</div>
                  |
                  <div class="dp-p1">Place of work：{{ item.address }}</div>
                  |
                  <div class="dp-p1">Salary range：{{ item.education }}</div>
                  |
                  <div class="dp-p1">Number of recruits：{{ item.exper }}</div>
                  |
                  <div class="dp-p1">Position Department：{{ item.rtype }}</div>
                </div>
              </div>
            </template>
            <div class="dp-bot">
              <div class="dp-pai">
                <div class="dp-sha">Operating duty</div>
                <div class="dp-xia" v-html="item.note"></div>
              </div>
              <div class="dp-pai">
                <div class="dp-sha">Job requirements</div>
                <div class="dp-xia" v-html="item.note1"></div>
              </div>
              <div class="dp-pai">
                <el-button class="el-button1" @click="clickResume(item)">Apply now</el-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <el-dialog title="Online resume" :visible.sync="dialogResume">
      <el-form
          :model="ruleForm2" ref="ruleForm2" label-position="top" class="el-form2">
        <el-form-item>
          <div class="dp-ti1">Applied for position: <b>{{ ruleForm2.position }}</b></div>
        </el-form-item>
        <el-form-item label="* Full name：" prop="name">
          <el-input v-model="ruleForm2.name"></el-input>
        </el-form-item>
        <el-form-item label="* ID number：" prop="id_card">
          <el-input v-model="ruleForm2.id_card"></el-input>
        </el-form-item>
        <el-form-item label="*Head portrait：" prop="path">
          <el-upload
              class="avatar-uploader" :action="stateBaseURL+stateUpload"
              :show-file-list="false" :on-success="onsuccessUpload">
            <img v-if="ruleForm2.path" :src="ruleForm2.path" class="avatar">
            <i v-else class="el-icon-user-solid avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="Sex：" prop="sex">
          <el-select v-model="ruleForm2.sex" style="width: 100%;">
            <el-option key="1" label="Male" value="1"></el-option>
            <el-option key="2" label="female" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* Date of birth：" prop="birthday">
          <el-date-picker
              style="width: 100%;" v-model="ruleForm2.birthday" type="date"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="* Nation：" prop="nation">
          <el-input v-model="ruleForm2.nation"></el-input>
        </el-form-item>
        <el-form-item label="* Native place：" prop="place">
          <el-input v-model="ruleForm2.place"></el-input>
        </el-form-item>
        <!--
        <el-form-item label="* 验 证 码：" prop="captcha">
          <el-input v-model="ruleForm2.captcha"></el-input>
        </el-form-item>
        -->
        <el-form-item>
          <el-button @click="submitForm2('ruleForm2')" class="el-button-sub">Submit information</el-button>
          <el-button @click="resetForm2('ruleForm2')" class="el-button-res">Reset information</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      dataSelectaddress_id: [],
      dataSelecttype_id: [],
      dialogResume: false,
      dataHomeblock: [],
      ruleForm: {
        title: '',
        address_id: '',
        type_id: '',
      },
      /*
      rules: {
        title: [{required: true, message: '请输入您想搜索的职位', trigger: 'blur'}],
        address_id: [{required: true, message: '请选择工作地点', trigger: 'change'}],
        type_id: [{required: true, message: '请选择职位类型', trigger: 'change'}],
      }
       */
      ruleForm2: {
        name: '',
        id_card: '',
        path: '',
        sex: '',
        birthday: '',
        nation: '',
        place: '',
        position: '',//应聘职业名称
        recruit_id: '',//应聘职业id
        // captcha: '',
      },
    }
  },
  computed: {
    ...mapState(['stateBaseURL', 'stateUpload'])
  },
  created() {
    this.dataRequestcontactus_workAddress()
    this.dataRequestcontactus_positionType()
    this.dataRequestcontactus_recruit()
  },
  methods: {
    // 文件上传成功
    onsuccessUpload(response, file, fileList) {
      if (response.code == 200) {
        this.ruleForm2.path = this.$store.state.stateimgBaseURL + response.data.info.file_way
        console.log(this.ruleForm2.path)
        this.$notify({
          message: 'Avatar uploaded successfully',
          type: 'success',
          duration: 2000
        })
      }
    },
    //  人才招聘-工作地点
    dataRequestcontactus_workAddress() {
      this.$api.user.contactus_workAddress().then(res => {
        this.dataSelectaddress_id = res.data.list
      })
    },
    //  人才招聘-职位类型
    dataRequestcontactus_positionType() {
      this.$api.user.contactus_positionType().then(res => {
        this.dataSelecttype_id = res.data.list
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataRequestcontactus_recruit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 人才招聘列表
    dataRequestcontactus_recruit() {
      let params = {
        ...this.ruleForm,
      }
      this.$api.user.contactus_recruit(params).then(res => {
        this.dataHomeblock = res.data.list
      })
    },

    clickResume(item) {
      this.dialogResume = true
      console.log(item)
      this.ruleForm2.position = item.title
      this.ruleForm2.recruit_id = item.recruit_id
    },

    submitForm2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataRequestcontactus_submitResume()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm2(formName) {
      this.$refs[formName].resetFields()
    },
    // POST提交简历
    dataRequestcontactus_submitResume() {
      let params = {
        ...this.ruleForm2,
      }
      this.$api.user.contactus_submitResume(params).then(res => {
        if (res.code != 200) {
          this.$notify({
            message: res.message,
            type: 'error',
            duration: 2000
          })
        } else {
          this.$notify({
            message: 'Submitted successfully',
            type: 'success',
            duration: 2000
          })
          this.$refs.ruleForm2.resetFields()
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
.about-recruit {
  .dn-form {
    .el-form1 {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-form-item {
        margin: 0 10px;
      }

      .el-button {
        background: $color2;
        color: #ffffff;
        font-size: 26px;
        padding: 7px 30px;
      }
    }
  }

  .dn-lower {
    .el-collapse1 {
      border: none;

      .el-collapse-item {
        margin: 0 0 25px;
        border: 1px solid $line1;
        transition: all .3s ease;

        &:hover {
          transform: scale(1.008);
          box-shadow: 0 0 10px rgba(0, 0, 0, .3);
        }

        ::v-deep .el-collapse-item__header {
          border: none;
          height: auto;
          line-height: inherit;
          padding: 30px 50px;

          .el-collapse-item__arrow {
            font-size: 26px;
          }

          &.is-active {
            background: $background1;

            * {
              color: $color1;
            }
          }
        }

        ::v-deep .el-collapse-item__wrap {
          border: none;
        }
      }

      .dp-top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .dp-zuo {
          font-size: 20px;
          color: #505050;
        }

        .dp-you {
          display: flex;
          align-items: center;

          .dp-p1 {
            margin: 0 20px;
          }
        }
      }

      .dp-bot {
        padding: 60px;
        display: flex;
        justify-content: space-between;

        .dp-pai {
          max-width: calc(100% / 3);

          &:last-of-type {
            margin-top: auto;
          }

          .dp-sha {
            font-size: 16px;
          }

          .dp-xia {
            line-height: 24px;
            margin: 10px 0 0;
          }

          .el-button1 {
            background: $color2;
            color: #ffffff;
          }
        }

      }
    }
  }

  .el-form2 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .el-form-item {
      width: 49%;
      margin-bottom: 10px;

      .avatar-uploader {
        ::v-deep .el-upload {
          cursor: pointer;
          position: relative;
          overflow: hidden;
          background: $background1;
        }

        .avatar-uploader-icon {
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .avatar {
          width: 100px;
          height: 100px;
          display: block;
        }
      }

      ::v-deep .el-form-item__label {
        padding: 0;
      }

      &:first-of-type, &:last-of-type {
        width: 100%;
      }

      .dp-ti1 {
        border-top: 1px solid $line1;
        padding: 10*$pc-conversion 0 0;

        b {
          color: #df0515;
        }
      }

      .el-button-sub {
        background: $color2;
        color: #ffffff;
        width: 49%;
      }

      .el-button-res {
        background: $background1;
        width: 49%;
      }
    }
  }
}


@media screen and (max-width: 768px) {
  .about-recruit {
    .dn-form {
      .el-form1 {
        flex-wrap: wrap;

        .el-form-item {
          width: calc(100% / 2 - 10 * $mobile-conversion);
          margin: 10px calc(10 * $mobile-conversion / 2);
        }

        .el-button {
          font-size: 30*$mobile-conversion;
          width: 100%;
          padding: 20*$mobile-conversion;
        }
      }
    }

    .dn-lower {
      .el-collapse1 {
        .el-collapse-item {
          margin: 0 0 25*$mobile-conversion;

          ::v-deep .el-collapse-item__header {
            padding: 20*$mobile-conversion 30*$mobile-conversion;

            .el-collapse-item__arrow {
              font-size: 36*$mobile-conversion;
            }
          }
        }

        .dp-top {
          flex-wrap: wrap;

          .dp-zuo {
            width: 100%;
            font-size: 28*$mobile-conversion;
            margin: 0;
          }

          .dp-you {
            flex-wrap: wrap;
            width: 100%;
            margin: 20*$mobile-conversion 0 0;

            .dp-p1 {
              margin: 5*$mobile-conversion 10*$mobile-conversion;
            }
          }
        }

        .dp-bot {
          padding: 30*$mobile-conversion;
          flex-wrap: wrap;

          .dp-pai {
            max-width: inherit;
            width: 100%;
            margin: 15*$mobile-conversion 0;

            .dp-sha {
              font-size: 26*$mobile-conversion;
            }

            .dp-xia {
              margin: 10*$mobile-conversion 0 0;
            }
          }

        }
      }
    }

    ::v-deep .el-dialog {
      width: 90%;
    }

    .el-form2 {
      .el-form-item {
        width: 100%;
        margin-bottom: 10*$mobile-conversion;

        .avatar-uploader {
          .avatar-uploader-icon {
            width: 100*$mobile-conversion;
            height: 100*$mobile-conversion;
          }

          .avatar {
            width: 100*$mobile-conversion;
            height: 100*$mobile-conversion;
          }
        }

        .dp-ti1 {
          padding: 10*$mobile-conversion 0 0;

        }

        .el-button-sub {
          width: 45%;
        }

        .el-button-res {
          width: 45%;
        }
      }
    }
  }
}
</style>
